export default {
    // 设置登录用户信息
    setUserInfo(state, info) {
        localStorage.setItem("userInfo", JSON.stringify(info));
        state.userInfo = info;
    },
    // 删除登录用户信息
    delUserInfo(state) {
        // localStorage.setItem("userInfo", null);
        localStorage.clear();
        state.userInfo = null;
    },

    // 设置项目ID
    setItems(state,id) {
        localStorage.setItem("itemId", id);
        state.itemId = id;
    },
    // 设置项目类型
    setItemTypes(state,type) {
        localStorage.setItem("itemType", type);
        state.itemType = type;
    },

    // 设置模块信息
    setModules(state,type) {
        // console.log(type,'type');
        localStorage.setItem("modulesAct", type);
        state.modulesAct = type;
    },
   
    // 设置模块信息
    setStepKey(state,key) {
        // console.log(key);
        // console.log(state,'state');
        localStorage.setItem("stepKey", key);
        state.stepKey = key;
    },
}


// WEBPACK FOOTER //
// ./src/store/mutations.js